const baseURL = 'https://catalogo.siscomweb.pe/';

export default baseURL;
